type AnalyticsFunction = (...args: unknown[]) => void;

declare global {
  interface Window {
    dataLayer?: unknown[][];
    gtag?: AnalyticsFunction;
  }
}

let initialized = false;
let lastTrackedPath: string | null = null;

function getMeasurementId() {
  return import.meta.env.VITE_GA_MEASUREMENT_ID?.trim();
}

export function initializeAnalytics() {
  if (initialized || typeof window === 'undefined') return;

  const measurementId = getMeasurementId();
  if (!measurementId) return;

  initialized = true;
  window.dataLayer = window.dataLayer ?? [];
  window.gtag = (...args) => {
    window.dataLayer?.push(args);
  };
  window.gtag('js', new Date());
  window.gtag('config', measurementId, {
    send_page_view: false,
    allow_google_signals: false,
    allow_ad_personalization_signals: false,
  });

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`;
  document.head.appendChild(script);
}

export function trackPageView(path: string) {
  if (typeof window === 'undefined' || !window.gtag || !getMeasurementId()) return;
  if (lastTrackedPath === path) return;

  lastTrackedPath = path;

  window.gtag('event', 'page_view', {
    page_title: document.title,
    page_location: `${window.location.origin}${path}`,
    page_path: path,
  });
}
